import axios from 'axios';

export const getReqShiftService = (reqistionShiftId: any) => {
    const url = `api/requisitions/requisitionshift/${reqistionShiftId}`;
    return axios.get(url);
  };
  
  export const getReqShiftsbyReqIdService = (reqId: string, query: string) => {
    const url = `api/requisitions/${reqId}/shifts?${query}`;
    return axios.get(url);
  };
  
  export const getShiftTypesService = () => {
    const url = `api/scheduling/shifttype`;
    return axios.get(url);
  };
  